module.exports = __webpack_public_path__ + "img/collection-weddingRingsForestGreen.7da1b0a.jpg";